<template></template>
<script>
export default {
  name: 'text-chat',
  data() {
    return {
      door: false,
      status: this.value,
      ws: null,
      statusTimer: null,
    }
  },
  props: {
    user_id: {
      type: String
    },
    app_id: {
      type: String
    },
    value: {
      type: Boolean
    },
    group_id:{
      type:String
    }
  },
  watch: {
    value(e) {
      this.status = e
    }
  },
  mounted() {
    this.onConnect()
  },
  methods: {
    onConnect() {
      console.log(this.user_id)
      if (!this.user_id) {
        return
      }

      //建立连接
      let ws = new WebSocket("wss://team-chat.learningfirst.cn:9000");
      ws.onerror = (err) => {
        console.log(err)
      };
      this.ws = ws

      // Expose ws to parent component
      this.$emit('getWsOut', ws);

      //对ws进行设置

      //成功建立的操作
      ws.onopen = () => {
        console.log('APP_ID:'+this.app_id)
        console.log('USER_ID:'+this.user_id)
        console.log('GROUP_ID:'+this.group_id)
        this.$message({
            message:'Connection Success',
            type:'success',
            duration:5000,
            showClose:true
        })
        this.changeStatus(true)
        ws.send(`user&${this.group_id}&${this.user_id}`);

        // Periodically check group connection status
        this.statusTimer = setInterval(() => {
          if (ws.readyState === WebSocket.OPEN) {
            ws.send('getGroupConnection');
          }
        }, 5000);
      };
      //关闭连接的操作
      ws.onclose = () => {
        this.changeStatus(false)
      }
      //接收到消息的操作
      ws.onmessage = (e) => {
        if(typeof e.data === 'string'){
          let data = e.data;
           //同步问题
           console.log(123,data)
          if (data.indexOf("correctQuestionSync") !== -1) {
            let obj = data.split("&")[1];
            obj = JSON.parse(obj);
            this.$emit("correctQuestionSync", obj);
            //同步图片
          } else if (data.indexOf("correctSessionPicSync") !== -1) {
            let obj = data.split("&")[1];
            obj = JSON.parse(obj);
            this.$emit("correctSessionPicSync", obj);
          } else if (data.indexOf("teamChat") !== -1) {
            // Handle team chat messages
            let obj = data.split("&")[1];
            obj = JSON.parse(obj);
            this.$emit("teamChatMessage", obj);
          } else if (data.indexOf("teamSubmit") !== -1) {
            // Handle team submission notifications
            let obj = data.split("&")[1];
            obj = JSON.parse(obj);
            this.$emit("teamSubmitNotification", obj);
          } else if (data.indexOf("onlineStatus") !== -1) {
            // Handle online status updates
            let obj = data.indexOf("&") !== -1 ? data.split("&")[1] : data;
            obj = JSON.parse(obj);
            this.$emit("onlineStatusUpdate", obj);
          } else if (data.indexOf("relay_") === 0) {
            // Relay messages handled by relayWs, ignore here
          } else {
            this.$message({
                message:'System Message: '+e.data,
                duration:5000,
                showClose:true
            })
          }
        }
      };

    },
    offConnect() {
      if (this.ws) {
        this.ws.close();
        this.changeStatus(false)
      }
    },
    changeStatus(bool) {
      this.status = bool
      this.$emit('input', bool)
    },
    // Method to send messages via socket
    sendMessage(type, data) {
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        this.ws.send(`${type}&${JSON.stringify(data)}`);
      }
    }
  },
  destroyed() {
    console.log('Socket Closed')
    this.offConnect()
    if (this.statusTimer) {
      clearInterval(this.statusTimer)
    }
  }
}
</script>